import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '../';

const ContainerLoader = () => {
  return (
    <Container title="Loading...">
      <div className="container-loader-spinner">
        <i className="fa fa-spinner fa-spin fa-5x fa-fw"></i>
        <br/>
        <span className="loading-text">
          Loading...
        </span>
      </div>
    </Container>
  );
}

export default ContainerLoader;



// WEBPACK FOOTER //
// ./src/browser/components/ui/containerLoader.js